import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { Redirect } from 'react-router-dom';
import IntegrationItem from './IntegrationItem';
import styles from './Integrations.module.scss';


const Integrations = ({
  clients,
  clientLogoUris,
  requestClients,
  unlinkClient,
  error,
  userIsLoggedIn
}) => {
  useEffect(() => {
    requestClients();
  }, []);

  const availableClients = useMemo(() => (
    clients.filter(({ enabled }) => enabled)
  ), [clients]);

  if (!userIsLoggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <div className={styles.integrations}>
        <div className={styles.centeredContainer}>
          <div className={styles.info}>
            <h1 className={styles.header}>
              Integrations
            </h1>
            <div className={styles.containerInfo}>
              <p>{'Matchbook offers a number of integrations with third party sites to provide you with a smoother betting experience whether on Matchbook or elsewhere.'}</p>
              <p>{'Below is a list of available integrations. Once integrated, the third party site will have the ability to access your betting records and may be able to place bets on your behalf.'}</p>
              <p>{'You may also revoke any integrations from this screen if you should so wish.'}</p>
            </div>
            <p className={styles.errorText}>
              {error}
            </p>
            {
              !availableClients.size ? (
                <div className={styles.noIntegrations}>
                  No Integrations available at this time
                </div>
              ) : availableClients.map(client => (
                <IntegrationItem
                  key={client.id}
                  client={client}
                  unlinkClient={unlinkClient}
                  logoUri={clientLogoUris.get(client.id)}
                />
              ))
            }
            <p className={styles.footerText}>
              {'Matchbook does not control the content displayed on third party websites.'} <br /><br />
              {'You are responsible for managing which third party sites  your account is integrated with. Matchbook reserves the right to switch off third party and/all integrations at any time without notice.'} <br /><br />
              {"All bets struck via a third party integrations are subject to Matchbook's terms and conditions and privacy policy. Matchbook accepts no responsibility for any failure of a third party system which may result in you being unable to place a bet on the Matchbook Exchange."}
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

Integrations.propTypes = {
  requestClients: PropTypes.func.isRequired,
  unlinkClient: PropTypes.func.isRequired,
  userIsLoggedIn: PropTypes.bool,
  clients: PropTypes.instanceOf(List).isRequired,
  clientLogoUris: PropTypes.instanceOf(Map).isRequired,
  error: PropTypes.string,
};

export default Integrations;
